export default __webpack_public_path__ + "static/media/04.87acb46d.png";